import { ComponentFactoryResolver, Directive, OnInit, ViewContainerRef } from '@angular/core';
import { FooterComponent } from '@app-shared/components/footers/footer.model';
import { getClientConfig } from '@config/client-config';

@Directive({
  selector: '[appFooterHost]',
})
export class FooterDirective implements OnInit {
  public copyrightyear = new Date().getFullYear();
  public clientConfig = getClientConfig().configuration;

  constructor(public viewContainerRef: ViewContainerRef, private componentFactoryResolver: ComponentFactoryResolver) {}

  ngOnInit(): void {
    this.loadFooterComponent();
  }

  private loadFooterComponent() {
    this.viewContainerRef.clear();
    if (this.clientConfig?.showLandingPage ?? this.clientConfig?.landingPageDetails?.footer?.component) {
      const component = this.componentFactoryResolver.resolveComponentFactory<FooterComponent>(
        this.clientConfig.landingPageDetails.footer.component
      );
      const componentRef = this.viewContainerRef.createComponent<FooterComponent>(component);
      componentRef.instance.data = { copyrightyear: this.copyrightyear };
    }
  }
}
